export default __webpack_public_path__ + "static/img-ei-5-58507d03c7c0ee5344052fcf3894cc6b.png";